import { localhostUrlBuilder, qubictronAppsUrlMap, qubictronUrlMap } from "@qubictron/url";
import {
  Assets,
  // Not available in @qubictron/url yet:
  // createRequestITQuoteUrl,
  // FREIGHT_URL,
  // QUBICTRON_PAYMENT_URL,
  QUBICTRON_SIGN_UP_URL,
  QubictronUrlBuilder,
} from "@qubictron/url/client";
import { DEFAULT_LANG, IS_APP_IN_IFRAME } from "shared/constants/common.constants";

export {
  createScacIconUrl,
  createParcelCarrierIconUrl,
  // Not available in @qubictron/url yet:
  // FREIGHT_URL,
  // LOGISTICS_EXPLORER_URL,
  // SHIPPING_REQUEST_URL,
} from "@qubictron/url/client";

export const createAirlineIconUrl = (iataCode: string): string => {
  return qubictronAppsUrlMap.prod().setPathname(`icons/airline_icons/${iataCode.toUpperCase()}.jpg`).build();
};

export const createSealineIconUrl = (scacCode: string): string => {
  return qubictronAppsUrlMap.prod().setPathname(`icons/sealine_icons/${scacCode.toUpperCase()}.jpg`).build();
};

export const INTEGRATION_APP_ORIGIN = new URL(
  IS_APP_IN_IFRAME && !!document.referrer ? document.referrer : window.location.href
).origin;

export const isQubictronDomain = (url: string): boolean => /(^|\.)qubictron\.(dev|com)$/i.test(new URL(url).hostname);
export const isQubictronAiDomain = (url: string): boolean => /(^|\.)qubictron\.ai$/i.test(new URL(url).hostname);
export const isLandRatesDomain = (url: string): boolean => /(^|\.)landrates\.(dev|com)$/i.test(new URL(url).hostname);
export const isAirRatesDomain = (url: string): boolean => /(^|\.)airrates\.(dev|com)$/i.test(new URL(url).hostname);
export const isLocalhost = (hostname: string): boolean => hostname === localhostUrlBuilder().hostname;

export const isAppIntegration = (() => {
  const checkIsAppIntegrated = (url: string): boolean => {
    return !isQubictronDomain(url) && !isLandRatesDomain(url) && !isAirRatesDomain(url) && !isQubictronAiDomain(url);
  };

  if (isLocalhost(new URL(window.location.href).hostname)) {
    return false;
  }

  // in iframe
  if (IS_APP_IN_IFRAME) {
    return checkIsAppIntegrated(new URL(document.referrer).origin);
  }

  // without iframe
  return checkIsAppIntegrated(new URL(window.location.href).origin);
})();

export const isAppComDomain = /qubictron\.com$/gi.test(window.location.hostname);

// The local stack answers on whatever port Docker exposes, and qubictronUrlMap
// has no port for it - without this the sign-in CTA points at a dead URL there.
// Production is untouched: the loc branch only fires on a .loc hostname.
const localOriginResolver = { loc: () => ({ url: window.location.origin }) };

// TODO: Replace SIGN_IN_URL after url package is updated
export const SIGN_IN_URL = (lang?: string) =>
  new QubictronUrlBuilder({ originResolverCallbackMap: localOriginResolver })
    .setPathname(`${lang !== DEFAULT_LANG ? `/${lang}` : ""}/auth/sign-in`)
    .build();
export const SIGN_UP_URL = QUBICTRON_SIGN_UP_URL;
// Not available in @qubictron/url yet:
// export const MARKETPLACE_CARD_URL = FREIGHT_URL;
// export const PAYMENT_URL = QUBICTRON_PAYMENT_URL;

export const appHash = __DEV__ ? new Date().getTime().toString() : __APP_VERSION__;

export const assets = new Assets({
  appFolder: __APP_FOLDER__,
  hash: appHash,
  originResolverCallbackMap: {
    localhost: () => ({ url: __APP_ORIGIN__ }),
    // Served from the site's own origin on the local stack, whatever port it uses.
    ...localOriginResolver,
  },
});

export const APP_STYLESHEET_HREF = assets.css.appBundleBuilder().build();
export const APP_FONTS_STYLESHEET_HREF = assets.css.fonts.bundleBuilder().build();
export const APP_FONTS_REGISTER_STYLESHEET_HREF = assets.css.fonts.bundleRegisterBuilder().build();
export const QUBICTRON_PROD_ORIGIN = qubictronUrlMap.prod().origin;

// The site serves one pricing page. The per-product paths this used to point at
// (pricing/tracking-system, pricing/air-tracking) have no route and answered 404.
export const PRICING_PAGE_URL = new QubictronUrlBuilder().setPathname("pricing").build();
/** Where "Buy QCredits" goes when the back office names no address of its own. */
export const CABINET_BILLING_URL = new QubictronUrlBuilder().setPathname("cabinet/billing").build();
export const INTEGRATION_PAGE_URL = new QubictronUrlBuilder().setPathname("request-it-quote").build();
export const PRICING_PAGE_TRACKING_SYSTEM_URL = PRICING_PAGE_URL;
export const PRICING_PAGE_AIR_TRACKING_URL = PRICING_PAGE_URL;
export const REQUEST_IT_QUOTE_CONTAINER_TRACKING_URL = "/request-it-quote?serviceTool=container-tracking";
export const REQUEST_IT_QUOTE_AIR_TRACKING_URL = "/request-it-quote?serviceTool=air-tracking";

//Pricing URLs
export const PRICING_CONTAINER_TRACKING_URL = `${PRICING_PAGE_URL}#container-tracking`;
export const PRICING_AIR_TRACKING_URL = `${PRICING_PAGE_URL}#air-tracking`;
export const PRICING_GLOBAL_TRACKING_URL = `${PRICING_PAGE_URL}#global-tracking`;

//Integration URLs
export const INTEGRATION_CONTAINER_TRACKING_URL = `${INTEGRATION_PAGE_URL}?serviceTool=container-tracking`;
export const INTEGRATION_AIR_TRACKING_URL = `${INTEGRATION_PAGE_URL}?serviceTool=air-tracking`;
export const INTEGRATION_GLOBAL_TRACKING_URL = `${INTEGRATION_PAGE_URL}`;
